import { render, staticRenderFns } from "./KBMessageComposer.vue?vue&type=template&id=7a161e88&scoped=true&"
import script from "./KBMessageComposer.vue?vue&type=script&lang=ts&"
export * from "./KBMessageComposer.vue?vue&type=script&lang=ts&"
import style0 from "./KBMessageComposer.vue?vue&type=style&index=0&id=7a161e88&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a161e88",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VMenu,VProgressCircular})
